exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.simple-card[data-v-0c762208] {\n  position: relative;\n  border-radius: 8px;\n  padding: 17px 15px 20px 15px;\n}\n.simple-card-title[data-v-0c762208] {\n  font-size: 24px;\n  font-weight: bold;\n  color: #3a3a3a;\n  margin-bottom: 10px !important;\n}\n.simple-card-overlay[data-v-0c762208] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n  opacity: 0%;\n  transition: 200ms;\n  background-color: black;\n}\n.simple-card[data-v-0c762208] {\n  margin: 30px 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-0c762208","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/rating/cards/Graph.vue
// module id = 902
// module chunks = 1